var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:_vm.liClasses},[_c('a',{class:_vm.linkClasses,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.$emit("click")}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }